var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.adfb2759c1f73dcfc0efb6a2618f4f2b.svg#zoom';
                    var viewUrl = 'svg/global.adfb2759c1f73dcfc0efb6a2618f4f2b.svg#view-zoom';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 30',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };